import type { HTMLComponent } from "@commercekit/react";
import classNames from "classnames";
import type { TextareaHTMLAttributes } from "react";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";
import { useField } from "remix-validated-form";

const WvTextareaField: HTMLComponent<
  {
    name: string;
    fieldClass?: string;
    label: string;
    required?: boolean;
    onChange?: (v: string, e: React.FormEvent<HTMLTextAreaElement>) => void;
  } & Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "onChange">
> = ({ name, fieldClass, label, required, onChange, ...props }) => {
  const { error, getInputProps, validate, clearError } = useField(name);
  const { $pt } = usePrismicLabels();

  return (
    <div className={classNames("mb-3", fieldClass)} {...props}>
      <div className={`input ${label ? "input--label" : ""}`}>
        <textarea
          {...getInputProps({ id: name, ...props })}
          className={classNames("form-control", error ? "error" : "normal")}
          onChange={(e) => {
            onChange?.(e.target.value, e);
            clearError();
          }}
          onBlur={() => {
            validate();
          }}
        />
        <span className="input__label">
          {$pt(label)} {required ? "*" : ""}
        </span>
        {error ? (
          <label className="error" htmlFor={name} style={{ marginTop: "-3px" }}>
            {$pt(error || "")}
          </label>
        ) : null}
      </div>
    </div>
  );
};

export default WvTextareaField;
